import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export function useIsSuperAdmin() {
  const { user, loading: authLoading } = useAuth();
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (authLoading) return;
    if (!user) { setIsSuperAdmin(false); setLoading(false); return; }

    let cancelled = false;

    (async () => {
      await supabase.auth.getSession();
      const { data } = await supabase
        .from("user_roles")
        .select("role")
        .eq("user_id", user.id)
        .eq("role", "super_admin")
        .limit(1)
        .maybeSingle();

      if (!cancelled) {
        setIsSuperAdmin(!!data);
        setLoading(false);
      }
    })();

    return () => { cancelled = true; };
  }, [user, authLoading]);

  return { isSuperAdmin, loading };
}
